import { parseRouteParamToInt } from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

export const DEFAULT_CITY_ID = 0;

export type ListingsSearchSitemapByCityIDRouteParams = {
  citySlugOrListingTypeID: string;
  cityID: number;
};

export type ListingsSearchSitemapByCityIDRouteParamsString = {
  citySlugOrListingTypeID: string;
  cityID: string;
};

export const ListingsSearchSitemapByCityID = defineRoute<
  ListingsSearchSitemapByCityIDRouteParams,
  ListingsSearchSitemapByCityIDRouteParamsString
>({
  pathname: '/sitemap/[citySlugOrListingTypeID]/[cityID]', // for this route [citySlugOrListingTypeID] means `citySlug`
  routeParamsStringifier: routeParams => {
    return {
      citySlugOrListingTypeID: routeParams.citySlugOrListingTypeID,
      cityID: routeParams.cityID.toString(),
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      citySlugOrListingTypeID: routeParamsString.citySlugOrListingTypeID,
      cityID: parseRouteParamToInt(routeParamsString.cityID) || DEFAULT_CITY_ID,
    };
  },
});
